<section class="contact-page">
  <div class="contact-intro">
    <p class="eyebrow">{{ language.isEnglish ? 'Contact · Studio' : 'Contact · Atelier' }}</p>
    <h1><span>{{ language.isEnglish ? 'Let’s talk' : 'Parlons' }}</span><em>{{ language.isEnglish ? 'about art.' : 'd’art.' }}</em></h1>
    <span class="title-stroke" aria-hidden="true"></span>
  </div>
  <div class="contact-card">
    <p class="lead">
      <span class="lead-mark" aria-hidden="true"></span>
      <span>{{ language.isEnglish ? 'For exhibitions, commissions, collaborations, or to acquire a painting, please feel free to contact me directly.' : 'Pour une exposition, une commande, une collaboration ou l’acquisition d’une peinture, contactez-moi directement.' }}</span>
    </p>
    <p class="label">{{ language.isEnglish ? 'Email address' : 'Adresse e-mail' }}</p>
    <div class="email-row">
      <a [href]="'mailto:' + defaultEmail">{{ defaultEmail }} <span aria-hidden="true">&nearr;</span></a>
      <button type="button" (click)="copyEmail()" [attr.aria-label]="(language.isEnglish ? 'Copy ' : 'Copier ') + defaultEmail">{{ language.isEnglish ? 'Copy' : 'Copier' }}</button>
    </div>
    <p class="copy-state" [class.visible]="copied">{{ language.isEnglish ? 'Address copied' : 'Adresse copiée' }}</p>
    <div class="location"><span aria-hidden="true"></span><p>Val d&apos;Oise<br><small>France</small></p></div>
  </div>
</section>
